import "jquery-address"

import { Bizq } from "./viz-base"

import * as Ui from "./util/ui"
import * as Strings from "./util/string"
import * as Form from "./util/form"
import { State } from "./util/state"
import { getLanguage } from "./util/language"
import { trilingual } from "./viz/i18n"
import { Widget } from "./viz/widget"
import { PowerSearch } from "./powersearch"
import { registerSiteWidgets } from "./site/widgets"
import { initializeTooltip, initializeTooltips } from "./site/tooltip"
import { animateNumericLabel, setupLightbulbAnimation } from "./site/animation"
import {
  recreate as recreateSegmentCodeDropdown,
  clear as clearSegmentCodeDropdown,
} from "./site/search/segment-code-dropdown"
import {
  AddressSearch,
  initializeAddressSearch,
} from "./site/search/address-search"
import {
  drawSearchResultMap,
  SearchResultMap,
} from "./site/search/search-result-map"
import { importDataTable } from "./dynamic-modules"
import { addViewportHandler, debounce } from "./util/dom"
import Rupt from "rupt"
import type { Vidyard } from "./declaration/vidyard"
import { initializeCollapseComponent } from "./site/components/collapse"
import { initializePublicationSearch } from "./site/components/searchable-list"

if (top != self) {
  top!.location.replace(self.location.href)
}

const language = getLanguage()

registerSiteWidgets()

module Advertising {
  type ClickyFunc = (clicky: any) => void
  function exec(clickyFunc: ClickyFunc) {
    const clicky = (window as any)["clicky"]
    if (clicky) {
      clickyFunc(clicky)
    } else {
      window.setTimeout(function () {
        exec(clickyFunc)
      }, 500)
    }
  }
}

module Print {
  const printDialog = $(".modal.dossier")
  const printDialogOK = printDialog.find(".ok")
  function showPrintDialog() {
    printDialog["modal"]("show")
  }
  function submitPrintJob() {
    printDialogOK.addClass("loading")
    const params: Record<string, any> = {}
    const tab = $("div.dossier div.tab.active").data("tab")
    params["type"] = tab

    if (tab === "beta") {
      // new dossier dialog
      const companyId = $("form[name='dossier-beta']").data("company")
      params["companyId"] = companyId
      $("form[name='dossier-beta'] input").each(function () {
        const input = this as HTMLInputElement
        const value = input.getAttribute("value")
        if (input.checked) {
          params["level"] = value
        }
      })
    } else {
      // legacy dossier dialog, to be deleted
      $("form[name='dossier-classic'] input").each(function () {
        const input = this as HTMLInputElement
        const key = input.getAttribute("name")
        if (key) {
          const checked = input.checked
          State.setValue(key, checked)
          if (checked) {
            params[key] = checked
          }
        }
      })
    }
    const payload = {
      title: document.title,
      url: document.location.href,
      params,
    }
    $.ajax("/_render_pdf", {
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify(payload),
      success: submitPrintJobOk,
    })
    return false
  }
  function submitPrintJobOk() {
    printDialogOK.removeClass("loading")
    printDialog["modal"]("hide")
  }
  printDialog["modal"]({ onApprove: submitPrintJob as () => void })
  const showDialogButton = $("#print")
  showDialogButton.click(showPrintDialog)
}

module Watch {
  const noteDialog = $(".modal.note")
  const noteDialogOK = noteDialog.find(".ok")
  const watchDialog = $(".modal.watch")
  const watchDialogOK = watchDialog.find(".ok")
  const watchDialogError = watchDialog.find(".ui.small.icon.message.error")
  function showWatchDialog() {
    watchDialog["modal"]("show")
  }
  function showNoteDialog(name: any, uri: any, note: any) {
    $("#note").val(note)
    noteDialog["modal"]("show")
    $(noteDialog).data("note-name", name)
    $(noteDialog).data("note-uri", uri)
  }
  function submitWatchJob() {
    watchDialogOK.addClass("loading")
    const params: Record<string, any> = {}
    $("form[name='dossier'] input").each(function () {
      const input = this as HTMLInputElement
      const key = input.getAttribute("name")
      if (key) {
        const checked = input.checked
        State.setValue(key, checked)
        if (checked) {
          params[key] = checked
        }
      }
    })
    const payload = {
      uri: watchDialog.data("watch-uri"),
      name: watchDialog.data("watch-name"),
      note: $("#note").val() as String,
    }
    $.ajax("/rpc.json/user/addWatch", {
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify(payload),
      success: submitWatchJobOk,
    })
    return false
  }
  interface AddWatchResult {
    messageType: "error"
  }
  function submitWatchJobOk(data: AddWatchResult) {
    watchDialogOK.removeClass("loading")
    if (data.messageType === "error") {
      watchDialogError.removeClass("hidden")
    } else {
      watchDialog["modal"]("hide")
      document.location.assign("/_watches")
    }
  }
  function submitNoteJob() {
    noteDialogOK.addClass("loading")
    const payload = {
      uri: noteDialog.data("note-uri"),
      name: noteDialog.data("note-name"),
      note: $("#note").val() as String,
    }
    $.ajax("/rpc.json/user/updateWatch", {
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify(payload),
      success: submitNoteJobOk,
    })
  }
  function submitNoteJobOk() {
    noteDialogOK.removeClass("loading")
    noteDialog["modal"]("hide")
    document.location.reload()
  }
  noteDialog["modal"]({ onApprove: submitNoteJob as () => void })
  watchDialog["modal"]({ onApprove: submitWatchJob as () => void })
  const showDialogButton = $("#watch")
  showDialogButton.click(showWatchDialog)
  const showNoteButton = $(".notebutton")
  showNoteButton.click(function () {
    const name = this.getAttribute("data-watch-name")
    const uri = this.getAttribute("data-watch-uri")
    const note = this.getAttribute("data-watch-note")
    showNoteDialog(name, uri, note)
  })
}

module PremiumServices {
  $(() => {
    const cards = $(".premium-services__card")
    const buttons = $(".premium-services__control .button")

    buttons.on("click", (e) => {
      const button = $(e.currentTarget)
      if (button.hasClass("active")) {
        return
      }

      const planVariantId = button.data("id")
      if (!planVariantId) {
        return
      }

      const targetCard = cards.filter(
        (_index, element) => $(element).data("id") === planVariantId
      )
      if (targetCard.length) {
        buttons.removeClass("positive")
        cards.removeClass("active")
        button.addClass("positive")
        targetCard.addClass("active")
      }
    })
  })
}

module SearchExport {
  const exportDialog = $(".modal.export")
  const exportDialogOK = exportDialog.find(".ok")
  function showExportDialog() {
    exportDialog["modal"]("show")
  }
  function submitExportJob() {
    exportDialogOK.addClass("loading")
    const params = Strings.fromQueryString(document.location.search)
    const limit = $("form[name='export'] input[name='limit']").val()
    params["limit"] = limit
    $.ajax("/_sre", {
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify(params),
      success: submitExportJobOk,
    })
    return false
  }
  function submitExportJobOk() {
    exportDialogOK.removeClass("loading")
    exportDialog["modal"]("hide")
  }
  exportDialog["modal"]({ onApprove: submitExportJob as () => void })
  const showDialogButton = $("#export,#export2")
  showDialogButton.click(showExportDialog)
}

module Geo {
  let addressSearch: AddressSearch
  let searchResultMap: SearchResultMap

  export function initSearchBox(searchElement: HTMLElement) {
    addressSearch = initializeAddressSearch(searchElement)
  }

  export function restrictAutocomplete(countries: string[]) {
    addressSearch.applyFilter(countries)
  }

  export function addNewSearchResultMarkers() {
    searchResultMap?.addNewMarkers()
  }

  $(async function () {
    const mapElement = document.getElementById("search-map")
    if (mapElement) {
      searchResultMap = await drawSearchResultMap(mapElement)
    }
  })
}

// NAG SUPPORT
$(".message .close-message").on("click", function (e) {
  e.preventDefault()

  const message = $(this).closest(".message")
  message["transition"]("fade")
  State.setValue(message.data("key"), "hide")
})

function dump(name: string, object: any): void {
  try {
    console.info(name, JSON.stringify(object, null, 2))
  } catch (error) {
    console.info(name, object)
  }
}

module Site {
  Form.manageAll()

  initializeTooltips()

  $(function () {
    const $closeButton = $(".search .label .link")
    const $searchInput = $(".search input")
    if ($closeButton.length > 0 && $searchInput.length > 0) {
      const closeButtonUpdate = function () {
        const searchInputText = $searchInput.val()
        const hasText =
          typeof searchInputText === "string" && searchInputText.length > 0
        $closeButton.toggleClass("visible", hasText)
      }
      $searchInput.on("input", closeButtonUpdate)
      $closeButton.on("click", function () {
        $closeButton.toggleClass("visible", false)
        $searchInput.val("").focus()
      })
      closeButtonUpdate()
    }

    // Semantic-UI based-search box
    type SearchEntry = {
      name: string
      title: string
      description: string
      url: string
      type: "company" | "person"
    }

    const COUNTRY_DELIMITER = "|"
    const universalCountrySelection = $(
      ".universal-search .ui.country.dropdown"
    )
    function getSelectedCountries() {
      const value = universalCountrySelection.dropdown("get value") as string
      return value.split(COUNTRY_DELIMITER).sort().join(COUNTRY_DELIMITER)
    }

    const simpleSearchInput = $(".ui.search.simple")
    simpleSearchInput.search({
      apiSettings: {
        url: "/suggest.json?query={query}&countries={countries}",
        beforeSend: function (settings: FomanticUI.APISettings) {
          settings.urlData.countries = getSelectedCountries()
          return settings
        },
        onResponse: function (response) {
          const categories = {
            company: {
              name: trilingual("Company", "Firma", "Entreprise"),
              results: [] as SearchEntry[],
            },
            person: {
              name: "Person",
              results: [] as SearchEntry[],
            },
          }
          if (response && response.results) {
            const counts: { [key: string]: number } = {}
            const entryKey = (entry: SearchEntry) =>
              entry.title + entry.description
            const getCount = (entry: SearchEntry): number =>
              counts[entryKey(entry)] || 0
            const setCount = (entry: SearchEntry, count: number): number =>
              (counts[entryKey(entry)] = count)
            const incCount = (entry: SearchEntry): number =>
              setCount(entry, getCount(entry) + 1)
            for (let i = 0; i < response.results.length; ++i) {
              const result = response.results[i] as SearchEntry
              const category = categories[result.type]
              if (category && category.results) {
                incCount(result)
                if (result.title.length > 1) {
                  category.results.push(result)
                }
              }
            }
            // deduplicate people
            const personResults = [] as SearchEntry[]
            const seen: { [key: string]: boolean } = {}
            for (const result of categories.person.results) {
              const count = getCount(result)
              if (count == 1) {
                personResults.push(result)
              } else {
                const key = entryKey(result)
                if (!seen[key]) {
                  seen[key] = true
                  const url = result.url
                  const index = url.lastIndexOf("/")
                  result.url = url.substring(0, index)
                  result.description =
                    result.description +
                    " (" +
                    count +
                    " " +
                    trilingual("results", "Resultate", "résultats") +
                    ")"
                  personResults.push(result)
                }
              }
            }
            categories.person.results = personResults
          }
          const content = { results: categories }
          return content
        },
      },
      onSelect: function (result: SearchEntry) {
        if (result) {
          if (result.url) {
            simpleSearchInput.addClass("loading")
            // Fomantic will redirect to the selected result
            return
          }
          let name = Strings.unescape(result.name)
          if (name) {
            let query = name
            let address = Strings.unescape(result.description)
            if (address) {
              const indexOfPostalCode = address.indexOf("D-")
              if (indexOfPostalCode >= 0) {
                address = address.substring(indexOfPostalCode + 8)
              }
              query += ", " + address
            }
            search(query)
          }
        }
      },
      type: "category",
    })

    function search(query: string) {
      if (query) {
        simpleSearchInput.addClass("loading")
        // 1st try: encode dot:  does not work because Chrome immediately deencodes
        //const path = "/" + Strings.encode(query.trim()).replace(/\./g, "%2E")
        // 2nd try: replace dot by space - not nice, but works
        // 3rd try: replace dot by middle dot (and change them back later on the server)
        let path =
          "/" +
          Strings.encode(
            query.trim().replace(/\./g, "·")
            // this is not yet proven to be required:
            // .replace(/\//g, "∕")
          )
        // console.info("new path: " + path)
        if (query == "admin") {
          path += "?s=1" // hide the entry point of the admin UI
        }
        window.location.assign(path)
      }
    }

    $(document).on("submit", "form[role='search']", function (event) {
      event.preventDefault()
      const query = $(this).find("input[name='query']").val()
      if (typeof query === "string") {
        search(query)
      }
    })

    $(document).on(
      "click",
      "form[role='search'] .simple.search i.icon",
      function () {
        $(this).closest("form").submit()
      }
    )

    const params = Strings.fromQueryString(document.location.search)
    $(function () {
      type Runner = () => void
      const runners = (window as any)["runners"] as Runner[]
      if (runners) {
        for (const runner of runners) {
          runner()
        }
      }
    })

    $(".search-select .item").tab()
    if (params["search"] === "power") {
      $("button[data-tab=power]").trigger("click")
      PowerSearch.writePowerSearchInput(params)
    }
    $(document).on("submit", "form.power-search", function (event) {
      event.preventDefault()
      $(this).find("button[type=submit]").addClass("loading")
      const params = PowerSearch.readPowerSearchInput()
      const path = "/?" + Strings.toQueryString(params)
      window.location.assign(path)
    })

    $(document.body).on("click", "a[data-load-href]", function (e) {
      if (e.isDefaultPrevented() || e.metaKey || e.ctrlKey) {
        return
      }
      const href: string = this.getAttribute("data-load-href") ?? ""
      const target: string = this.getAttribute("data-load-target") ?? ""
      const replace: boolean = "true" == this.getAttribute("data-load-replace")
      const $target = $(target) || $(this)
      Ui.setWaiting(true)
      $(target).load(href, (_responseText, _textStatus, jqXHR) => {
        jqXHR
          .done(() => {
            // on success
            if (replace) {
              $target.children().appendTo($target.parent())
              $target.remove()
            }
            Geo.addNewSearchResultMarkers()
          })
          .always(() => {
            Ui.setWaiting(false)
          })
      })
      e.preventDefault()
    })

    // Potential issue: this initialization is very general and will override the ones that happen before (e.g. in power search)
    $(".ui.dropdown:not(.indicator-filter):not(.country)").dropdown({
      message: {
        noResults: trilingual(
          "No results",
          "Keine Resultate",
          "Aucun résultats"
        ),
      },
      fullTextSearch: true,
    })

    $(".ui.address.search").each((_, element) => Geo.initSearchBox(element))

    $(".ui.distance-unit.dropdown").dropdown({
      onChange(value: string) {
        State.setValue("distanceUnit", value)
      },
    })

    const segmentCodeStandardDropdown = $(".ui.segment-code-standard.dropdown")
    segmentCodeStandardDropdown.dropdown({
      onChange(value: string) {
        State.setValue("standard", value)
        clearSegmentCodeDropdown()
        recreateSegmentCodeDropdown(value)
      },
    })

    recreateSegmentCodeDropdown(
      segmentCodeStandardDropdown.dropdown("get value") as string
    )

    const powerCountrySelection = $(".power-search .ui.country.dropdown")
    const availableCountries = powerCountrySelection
      .find(".item")
      .map((_, menuItem) => menuItem.dataset.value!.toLowerCase())
      .get()

    const countryGroupsMap: Record<string, string[]> = {}
    powerCountrySelection
      .find(".menu > .country-group-item")
      .each(function (_index, item) {
        const groupId = item.dataset.value!.toLowerCase()
        const groupCountryCodes = item.dataset.group!.toLowerCase()
        countryGroupsMap[groupId] = groupCountryCodes.split("|")
      })

    const getCountryRestriction = (selectedValuesString: string) => {
      const selectedValues =
        selectedValuesString !== ""
          ? selectedValuesString.toLowerCase().split(",")
          : availableCountries

      const selectedCountryCodes = selectedValues.reduce(
        (acc: string[], value: string) => {
          const countryCodes = countryGroupsMap[value] ?? [value]
          for (const code of countryCodes) {
            acc.push(code)
          }
          return acc
        },
        []
      )
      return selectedCountryCodes
    }

    const dividerElement = powerCountrySelection.find(".menu > .divider")
    function applyDividerVisibility(selectedCountryString: string) {
      const selectedCountries = selectedCountryString.toLowerCase().split(",")
      const allCountryGroupsSelected = Object.keys(countryGroupsMap).every(
        function (value) {
          return selectedCountries.indexOf(value) >= 0
        }
      )
      dividerElement.toggle(!allCountryGroupsSelected)
    }

    powerCountrySelection.dropdown({
      action: "combo",
      onChange(value: string) {
        applyDividerVisibility(value)

        const isEmptySelection = value === ""
        const countryRestriction = isEmptySelection
          ? []
          : getCountryRestriction(value)
        Geo.restrictAutocomplete(countryRestriction)
        PowerSearch.restrictFilters(countryRestriction)
      },
    })
    if (powerCountrySelection.length) {
      const selectedCountries = powerCountrySelection.dropdown(
        "get value"
      ) as string
      const isEmptySelection = selectedCountries === ""
      const countryRestriction = isEmptySelection
        ? []
        : getCountryRestriction(selectedCountries)
      Geo.restrictAutocomplete(countryRestriction)
      PowerSearch.restrictFilters(countryRestriction)
    }

    universalCountrySelection.dropdown({
      action: "combo",
      delimiter: COUNTRY_DELIMITER,
      label: {
        transition: "fade left",
      },
      onChange(value) {
        State.setValue("countries", value)

        // clear existing results and cache of autocomplete so we get results from selected countries
        simpleSearchInput.search("clear cache")

        // the results container is reinitialized, where refresh is used to invalidate the existing reference
        simpleSearchInput.children(".results").remove()
        simpleSearchInput.search("refresh results")
        simpleSearchInput.search("create results")
      },
      onLabelSelect(selectedLabel) {
        if (selectedLabel) {
          universalCountrySelection.dropdown("toggle")
        }
      },
    })
    // Do not open popup menu on icon click as there is a tooltip attached
    universalCountrySelection
      .find(".info.icon")
      .on("click touchstart", (event) => event.stopPropagation())

    // Search box lightbulb animation
    setupLightbulbAnimation(
      $(".animated.outline.lightbulb.icon").closest(".ui.primary.segment"),
      "lightbulbAnimation"
    )

    const productStatistics = document.querySelector(".product-statistics")
    if (productStatistics != null) {
      addViewportHandler(productStatistics, "statistics", () => {
        $(".product-statistics .ui.label").addClass("animate-badge")
        $(".product-statistics .ui.label .value").each((_, element) => {
          animateNumericLabel(element, 100, 1500, 0.3)
        })
      })
    }

    const journalismCounter = document.querySelector(".journalism-counter")
    if (journalismCounter != null) {
      addViewportHandler(journalismCounter, "journalism", () => {
        $(journalismCounter)
          .addClass("animate-badge")
          .each((_, element) => animateNumericLabel(element, 100, 1500, 0.3))
      })
    }

    $(".download-link").each(function () {
      const link = $(this)
      if (!link.attr("download")) {
        link.attr("download", "")
      }
    })

    $(".ui.accordion").accordion()
    $(".admin-bar.ui.accordion").accordion("open", 0)

    $(".ui.input > .eye.reveal.icon").on("click", function () {
      const icon = $(this)
      const input = icon.siblings("input")
      const shouldReveal = input.prop("type") === "password"
      icon.toggleClass("slash", shouldReveal)
      input.prop("type", shouldReveal ? "text" : "password")

      const currentTitle = icon.prop("title")
      icon.prop("title", icon.data("alt-title"))
      icon.data("alt-title", currentTitle)
    })

    // Add empty alt attribute to decorative images
    $("img:not([alt])").prop("alt", "")
  })

  // Collapse component has to be intialized before data tables
  initializeCollapseComponent()

  initializePublicationSearch()
}

module WidgetInit {
  let barChartTabIndex = 0
  const print = $("html").hasClass("print")

  function handleBarChartItem(
    title: string,
    element: HTMLElement
  ): HTMLElement {
    const firstTab = barChartTabIndex == 0
    const tabClass = print ? "" : "ui bottom top attached tab "
    const activeClass = firstTab ? " active" : ""
    const tabName = "tab-bc-" + barChartTabIndex
    const headerItem = $("<button/>")
      .addClass("item" + activeClass)
      .attr("data-tab", tabName)
      .text(title)
    const censoredHeaderItems = $(".bar-charts .menu [data-censored]")
    if (censoredHeaderItems.length > 0) {
      headerItem.insertBefore(censoredHeaderItems.first())
    } else {
      headerItem.appendTo(".bar-charts .menu")
    }
    const $tabContent = $("<div>")
      .addClass("chart " + tabClass + activeClass)
      .attr("data-tab", tabName)
      .append($("<h4>").addClass("print-only").text(title))
      .append(element)
    barChartTabIndex++
    return $tabContent[0]
  }

  let drillDownTabIndex = 0
  function handleDrillDownItem(
    title: string,
    element: HTMLElement
  ): HTMLElement {
    const firstTab = drillDownTabIndex == 0
    const classesSuffix = firstTab ? " active" : ""
    const tabName = "tab-dd-" + drillDownTabIndex
    $("<button/>")
      .addClass("item" + classesSuffix)
      .attr("data-tab", tabName)
      .text(title)
      .appendTo(".drill-downs .menu .right.menu")

    const $tabContent = $("<div>")
      .addClass("chart ui tab" + classesSuffix)
      .attr("data-tab", tabName)
      .append($("<h4>").addClass("print-only").text(title))
      .append(element)
    drillDownTabIndex++
    return $tabContent[0]
  }

  function handleSheetItem(title: string, element: HTMLElement): HTMLElement {
    const $container = $("<div>")
      /*.append(
          $("<h4>")
            .addClass("print-only")
            .text(title)
          )*/

      .append(element)
    return $container[0]
  }

  function handleItem(this: Widget, title: string, element: HTMLElement) {
    const widgetType = this.getType()
    const item = element.getAttribute("data-item")
    if (item) {
      $("[data-show-for='" + item + "']").attr("data-show", "true")
    }
    switch (widgetType) {
      case "barChart":
        return handleBarChartItem(title, element)
      case "drillDown":
        return handleDrillDownItem(title, element)
      case "sheet":
        return handleSheetItem(title, element)
    }
  }

  $(function () {
    console.info(
      "started North Data Widget API " +
        (typeof Bizq.version === "undefined" ? "in debug mode" : Bizq.version)
    )

    let widgetsLoading = 0
    const loadingEnded = function () {
      --widgetsLoading
      if (widgetsLoading == 0) {
        // disable all print links
        $(".print a").each(function () {
          const node = this
          const href = node.getAttribute("href")
          if (href && href[0] != "#") {
            node.removeAttribute("href")
          }
        })
        ;(document as any)["bizqPageComplete"] = true
        const div = document.createElement("div")
        div.setAttribute("id", "bizqPageComplete")
        document.body.appendChild(div)
      }
    }
    $(".tabular.menu .item, .pointing.menu .item").tab()
    $("[data-layout]").each(function () {
      const $container = $(this)
      let width = Number($container.innerWidth())
      const tabName = $(this).parent(".tab").attr("data-tab")
      const $network = $container.closest(".network")
      const $charts = $container.closest(".financial.charts")
      const $treemaps = $container.closest(".financial.charts")
      const layout = $container.attr("data-layout")
      let maxItems = 12
      if (width < 900) {
        maxItems = 10
        if (width < 600) {
          maxItems = 8
          if (width < 400) {
            maxItems = 6
          }
        }
      }
      if (layout == "history") {
        maxItems = 20
        if (width < 900) {
          maxItems = 17
          if (width < 600) {
            maxItems = 12
            if (width < 400) {
              maxItems = 8
            }
          }
        }
      }
      let height
      let minHeight
      let data
      if ($charts.length > 0) {
        const $chart = $charts.children(".chart")
        height = $charts.children(".chart").height() ?? height
        width = $charts.children(".chart").width() ?? width
        minHeight = 270
      }
      ++widgetsLoading
      const companyClick = function (data: { url: string }) {
        const url = data["url"]
        if (url) {
          window.location.assign(url)
        }
      }
      function floor(number: number | undefined) {
        return number !== undefined ? Math.floor(number) : number
      }
      new Bizq.Widget(this, {
        rootColor: "#66afac",
        highlightBgColor: "#f3f4f5",
        language,
        minHeight,
        width: floor(width),
        height: floor(height),
        data,
        handleItem,
        linkify: (element: Element) => element.getAttribute("data-url"),
        companyClick: layout == "barChart" ? companyClick : null,
        load: function () {},
        success: function (this: Widget) {
          const drawMe = this.draw.bind(this)
          if (tabName) {
            $("button[data-tab='" + tabName + "']").on("click", drawMe)
          }
          if (layout == "barChart") {
            $(".bar-charts .menu .item").tab()
          }
          if (layout == "drillDown") {
            $(".drill-downs .menu .item").tab()
          }
          if (layout == "financials" || layout == "sheet") {
            $container
              .find("table")
              .addClass("ui very compact celled small styled table")
          }
          loadingEnded()
          $(window).resize(drawMe)
          $("[data-show-for='" + layout + "']").attr("data-show", "true")
          if (layout == "graph" || layout == "dendrogram") {
            $network.find(".dimmer").hide()
            $network.css("height", ($container.height() ?? 0) + 14)
            $network.find("figure").css("opacity", 1)

            setupExtendedLegend(this, $network)

            // debug distances
            $("body").keyup(function (event) {
              let keyCode = event.keyCode
              if (event.altKey && event.ctrlKey && keyCode == 68 /* d */) {
                event.preventDefault()
                $(".link[data-length]", $container).each(function () {
                  const length = this.getAttribute("data-length")
                  const text = $(this).find("text")
                  text.text(text.text() + " " + length)
                })
                $(".node[data-d]", $container).each(function () {
                  const rootDistance = this.getAttribute("data-d")
                  const text = $(this).find(".text")
                  //console.info(text.text() + ": " + rootDistance)
                })
              }
            })
          }
        },
        error: function (error: unknown) {
          loadingEnded()
          console.error("failed to create " + layout, error)
          $("[data-show-for='" + layout + "']").attr("data-show", "false")
          if (layout == "graph" || layout == "dendrogram") {
            $network.find(".dimmer").hide()
            $network.css("height", "55px")
          }
        },
        maxItems,
      })
    })

    function setupExtendedLegend(widget: Widget, container: JQuery) {
      const data = widget.data
      const hasLegend =
        typeof data === "object" && "legendHtml" in data && !!data.legendHtml
      if (!hasLegend) {
        return
      }

      const extendedLegendButtons = container.find(".extended-legend-button")
      extendedLegendButtons.parent().show()
      extendedLegendButtons.on("click", function () {
        $.modal({
          content: data.legendHtml as string,
          autofocus: true,
          class: "extended-legend",
          classContent: "unpadded",
          selector: { close: ".icon.close" },
          actions: [
            {
              text: trilingual("Close", "Schließen", "Fermer"),
              class: "primary small cancel",
            },
          ],
        }).modal("show")
      })

      initializeTooltip(extendedLegendButtons.filter(".tooltip-host"))
      setupLightbulbAnimation(
        container.find(".animated.lightbulb.icon").closest(".ui.segment"),
        "lightbulbAnimationLegend"
      )
    }
  })
}

module Publication {
  $(() => {
    $(".image-panel").each(function () {
      const imagePanel = $(this)
      const imageWrapper = $(`<div class="image-wrapper"><img></div>`)
      imageWrapper.insertBefore(imagePanel)

      imagePanel.find(".image-wrapper").on("click", function (event) {
        event.preventDefault()
        $(this).siblings().removeClass("active")
        $(this).addClass("active")
        imageWrapper
          .find("img")
          .attr("src", $(this).find("img").attr("src") as string)
      })

      imagePanel.find(".image-wrapper").first().trigger("click")
    })
  })
}

module InnovationRanking {
  $(() => {
    if ($("table.dataTable").length) {
      importDataTable().then(({ initializeDataTables }) => {
        initializeDataTables()

        Coverage.initializeCoverageFilters()
      })
    }
  })

  const countrySelection = $(".ui.country-select .ui.dropdown.country")
  countrySelection.dropdown({
    onChange: (value) => {
      countrySelection.addClass("loading")
      document.location.search = `innoCountry=${value}`
    },
  })
}

namespace Coverage {
  $(() => {
    // Initialize tabs
    const container = $(".coverage-container")
    const menuTabItems = container.find("#coverage-menu .item")
    if (menuTabItems.length) {
      menuTabItems.tab({ history: true, historyType: "hash" })
    }
  })

  export function initializeCoverageFilters() {
    const container = $(".coverage-container")
    if (!container.length) {
      return
    }

    // Intialize country tab filters
    const countryTab = container.find(".tab[data-tab=countries]")
    const countryFeatureTables = countryTab.find(".ui.table[data-country]")
    const countriesCountrySelection = countryTab.find(".country.selection")

    function toggleCountryFeatureTables(value: string) {
      const selectedCountries = value.split(",")
      countryFeatureTables.each(function () {
        const table = $(this)
        const isSelected =
          !value || selectedCountries.indexOf(table.data("country")) !== -1
        table.parent().toggle(isSelected)
      })
    }

    countriesCountrySelection.dropdown({
      action: "combo",
      onChange: toggleCountryFeatureTables,
    })
    toggleCountryFeatureTables(
      countriesCountrySelection.dropdown("get value") as string
    )

    // Intialize sources tab filters
    const sourcesTab = container.find(".tab[data-tab=sources]")
    const sourcesCountrySelection = sourcesTab.find(".country.selection")

    const sourcesDataTable = $(".ui.table.sources").DataTable()
    function filterSourcesTable(value: string) {
      if (!value) {
        sourcesDataTable.search("").draw()
        return
      }

      const query = value.replace(/,/g, "|")
      sourcesDataTable.search(query, true, false).draw()
    }

    sourcesCountrySelection
      .find(".menu")
      .prepend("<div class='item'>International</div>")
    sourcesCountrySelection.dropdown({
      action: "combo",
      onChange: filterSourcesTable,
    })
    filterSourcesTable(sourcesCountrySelection.dropdown("get value") as string)

    // Intialize indicators tab filters
    const indicatorsTab = container.find(".tab[data-tab=indicators]")
    const indicatorsCountrySelection = indicatorsTab.find(".country.selection")
    const indicatorsSelection = indicatorsTab.find(".indicator.selection")

    const countryKey = "country"
    const indicatorKey = "indicator"

    const indicators = indicatorsTab.find("tr.indicator")
    indicators.find("tr.country-row").each(function () {
      const tr = $(this)
      function getFilterData(name: string) {
        return tr
          .find(`[data-${name}]`)
          .map(function () {
            return $(this).data(name)
          })
          .get()
      }

      const countries = getFilterData(countryKey)
      tr.data(countryKey, countries)
    })

    function getQueryFn(element: JQuery) {
      const value = element.dropdown("get value") as string
      const query = !!value ? value.split(",") : []
      if (query.length) {
        query.push(`*`)
      }
      return function (rowData: string[]) {
        return (
          query.length === 0 ||
          query.some((option) => rowData.indexOf(option) !== -1)
        )
      }
    }

    function filterIndicatorsTable() {
      const countryQuery = getQueryFn(indicatorsCountrySelection)
      const indicatorQuery = getQueryFn(indicatorsSelection)

      const indicatorTables = indicatorsTab.find("table.indicators")

      indicatorTables.each(function () {
        const table = $(this)

        let hasVisibleIndicators = false
        const indicators = table.find("tr.indicator")
        indicators.each(function () {
          const tr = $(this)
          const countryRow = tr.find("tr.country-row")

          // Hide unselected countries
          countryRow.find(".country-item").each(function () {
            const item = $(this)
            const country = item.data("country")
            const showItem = countryQuery([country])
            item.toggle(showItem)
          })

          // Hide sources that do not match selected countries
          countryRow.find(".source.label").each(function () {
            const sourceLabel = $(this)
            const country = sourceLabel.data("source-country")
            const showSource = countryQuery([country])
            sourceLabel.toggle(showSource)
          })

          // Hide rows that have no matching country
          let hasVisibleCountries = false
          countryRow.each(function () {
            const row = $(this)
            const matchesCountry = countryQuery(row.data(countryKey))
            row.toggleClass("display-none", !matchesCountry)
            hasVisibleCountries = hasVisibleCountries || matchesCountry
          })
          tr.find(".no-matches").toggleClass(
            "display-none",
            hasVisibleCountries
          )

          // Hide unselected indicators
          const indicatorName = tr.data(indicatorKey)
          const matchesIndicator = indicatorQuery([indicatorName])
          tr.toggle(matchesIndicator)
          hasVisibleIndicators = hasVisibleIndicators || matchesIndicator
        })

        table.toggle(hasVisibleIndicators)
      })
    }

    indicatorsSelection.dropdown({
      action: "combo",
      fullTextSearch: true,
      onChange: filterIndicatorsTable,
    })
    indicatorsCountrySelection.dropdown({
      action: "combo",
      fullTextSearch: true,
      onChange: filterIndicatorsTable,
    })

    filterIndicatorsTable()
  }
}

module AccountSharing {
  async function installRupt(userId: string) {
    const url = window.location.protocol + "//" + window.location.host + "/"
    try {
      await Rupt.attach({
        client_id: "51c4ed55-8c1c-4e05-97f5-f430d40e4a1f",
        account: userId,
        email: userId,
        redirect_urls: {
          logout_url: url + "_logout",
          new_account_url: url + "_premium",
        },
      })
    } catch (error) {
      console.error("failed to load rupt", error)
    }
  }

  const accountEmail = document.body.getAttribute("data-account-email")
  if (accountEmail) {
    const ruptIsActive = document.body.getAttribute("data-rupt") === "true"
    const isDynamicPage = document.body.getAttribute("data-dynamic") === "true"
    if (ruptIsActive && isDynamicPage) {
      installRupt(accountEmail)
        .then(() => console.info("Rupt loaded"))
        .catch((error) => console.error("failed to load Rupt", error))
    }
  }
}

module Carousel {
  type CarouselRotation = "left" | "right"

  function moveToCarouselPage(
    carousel: JQuery<HTMLElement>,
    page: JQuery<HTMLElement>,
    rotation: CarouselRotation
  ) {
    const carouselContent = carousel.find(".carousel-content")
    const activePage = carouselContent.find(".carousel-page.active")

    // Prevent actions while page is still animating
    if (activePage.queue().length) {
      return
    }

    const pageIndex = page.index() as number
    const carouselNavItems = carousel.find(".carousel-nav").children()
    carouselNavItems.filter(".active").removeClass("active")
    carouselNavItems.eq(pageIndex).addClass("active")

    // Hide all inactive pages to avoid issues when resizing the window
    const isRightRotation = rotation === "right"
    const width = carouselContent.outerWidth() as number
    carouselContent
      .find(".carousel-page:not(.active)")
      .animate({ left: isRightRotation ? width : -width }, 1)

    activePage
      .removeClass("active")
      .animate({ left: isRightRotation ? -width : width })
    page.addClass("active").animate({ left: 0 })
  }

  function getCarouselPage(
    carousel: JQuery<HTMLElement>,
    rotation: CarouselRotation
  ) {
    const isRightRotation = rotation === "right"
    const currentPage = carousel.find(".carousel-page.active")
    let page = isRightRotation
      ? currentPage.next(".carousel-page:not('.active')")
      : currentPage.prev(".carousel-page:not('.active')")
    if (page.length === 0) {
      const tabs = currentPage.siblings(".carousel-page:not('.active')")
      page = tabs.eq(isRightRotation ? 0 : tabs.length - 1)
    }
    return page
  }

  function onNavigationClick(navItem: JQuery<HTMLElement>) {
    const carousel = navItem.closest(".carousel-container")
    const pages = carousel.find(".carousel-page")
    const activePageIndex = pages.filter(".active").index() as number
    const index = navItem.index() as number
    if (index === activePageIndex || index >= pages.length) {
      return
    }

    const rotation: CarouselRotation =
      index < activePageIndex ? "left" : "right"
    const nextActivePage = pages.eq(index)
    moveToCarouselPage(carousel, nextActivePage, rotation)
  }

  function rotateCarousel(carousel: JQuery<HTMLElement>) {
    const nextActivePage = getCarouselPage(carousel, "right")
    moveToCarouselPage(carousel, nextActivePage, "right")
  }

  $(() => {
    const container = $(".carousel-container")
    container.each(function () {
      const carousel = $(this)
      const carouselContent = carousel.find(".carousel-content")
      const carouselNav = carousel.find(".carousel-nav")
      const pages = carousel.find(".carousel-page")

      if (pages.length <= 1) {
        carousel.find(".carousel-button").css("display", "none")
        carouselNav.css("display", "none")
      }

      const offset = carouselContent.outerWidth() as number
      pages.each(function () {
        const page = $(this)
        const isActive = page.hasClass("active")
        if (!isActive) {
          page.css("left", offset)
        }

        $("<button/>")
          .addClass("carousel-nav-button")
          .toggleClass("active", isActive)
          .on("click", () => onNavigationClick($(this)))
          .appendTo(carouselNav)
      })
    })

    function updatePageSizes() {
      const pages = container.find(".carousel-page")
      pages.css("min-height", "")

      let maxHeight = 0
      pages.each(function (i) {
        const height = $(this).outerHeight() ?? 0
        if (height > maxHeight) maxHeight = height
      })
      const carouselContent = container.find(".carousel-content")
      carouselContent.css("min-height", maxHeight)
      pages.css("min-height", maxHeight)
    }

    if (container.length) {
      updatePageSizes()
      $(window).on("resize", debounce(updatePageSizes, 50))
    }

    $(".carousel-container").each(function () {
      const carousel = $(this)
      const interval = carousel.data("interval")
      if (interval) setInterval(() => rotateCarousel(carousel), interval)
    })
  })
}

module ConsentManager {
  const loadedScripts: string[] = []
  function loadScript(
    src: string,
    options?: {
      onLoad?: () => void
      async?: boolean
      defer?: boolean
      id?: string
    }
  ) {
    if (loadedScripts.indexOf(src) !== -1) {
      return
    }

    const script = document.createElement("script")
    if (options?.id) {
      script.id = options.id
    }
    if (options?.onLoad) {
      script.onload = options.onLoad
    }
    if (options?.async) {
      script.async = options.async
    }
    if (options?.defer) {
      script.defer = options.defer
    }
    script.src = src
    document.head.appendChild(script)
    loadedScripts.push(src)
  }

  function loadGoogleTagManager() {
    const gtmId = "GTM-K3NH5F2"
    const globalWindow = window as any
    globalWindow["dataLayer"] = globalWindow["dataLayer"] || []
    globalWindow["dataLayer"].push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    })
    loadScript(`https://www.googletagmanager.com/gtm.js?id=${gtmId}`, {
      async: true,
    })
  }

  function initalizePlaylistControls(player: Vidyard.Player) {
    const container = $(player.container)
    const playlistDotsContainer = container
      .closest(".vidyard-playlist")
      .next(".video-playlist-dots")

    const hasPlaylistControls = playlistDotsContainer.length > 0
    if (!hasPlaylistControls) {
      return
    }

    const updatePlaylistControls: Vidyard.StatusCallback = (
      _status,
      player
    ) => {
      const chapters = player.metadata?.chapters_attributes
      if (!player.ready() || !chapters || !player.status) return

      const currentTime = player.status.currentTime
      const currentVideoIndex = player.getCurrentVideoIndex()
      const nChapters = chapters.length

      const lastUpdateTime = playlistDotsContainer.data("lastUpdateTime")
      const nDots = playlistDotsContainer.data("chapters")
      const activeDotIndex = playlistDotsContainer.data("activeDot")
      const didVideoIndexChange = currentVideoIndex !== activeDotIndex

      if (
        lastUpdateTime != null &&
        didVideoIndexChange &&
        currentTime > lastUpdateTime
      ) {
        // skip invalid status updates
        return
      }

      playlistDotsContainer.data("lastUpdateTime", currentTime)

      const shouldRecreateDots = nDots !== nChapters
      if (shouldRecreateDots) {
        playlistDotsContainer.data("chapters", nChapters)
        playlistDotsContainer.empty()
        for (let idx = 0; idx < nChapters; ++idx) {
          const chapterName = chapters[idx]?.video_attributes?.name ?? ""
          playlistDotsContainer.append(
            $("<i>")
              .addClass("secondary circle icon")
              .attr("title", chapterName)
              .attr("aria-label", chapterName)
              .on("click", () => player.playVideoAtIndex(idx))
          )
        }
      }

      const shouldUpdateDots =
        currentVideoIndex != null && (shouldRecreateDots || didVideoIndexChange)
      if (shouldUpdateDots) {
        playlistDotsContainer.data("activeDot", currentVideoIndex)
        playlistDotsContainer.children(".icon").each(function (index) {
          $(this).toggleClass("outline", index !== currentVideoIndex)
        })
      }
    }

    player.on("status", updatePlaylistControls)
  }

  function loadVidyard() {
    $(".vidyard-video .consent-disclaimer").remove()
    if ($(".vidyard-player-embed").length) {
      window.onVidyardAPI = ({ players }: Vidyard.Vidyard) => {
        players.forEach(initalizePlaylistControls)
      }
      loadScript("https://play.vidyard.com/embed/v4.js")
    }
  }

  function loadHubspotForms() {
    const forms = $("#contact-form")
    if (forms.length) {
      loadScript("//js.hsforms.net/forms/v2.js", {
        onLoad: () => initializeHubspotForms(forms),
      })
      loadScript("//js.hs-scripts.com/6118348.js", {
        async: true,
        defer: true,
        id: "hs-script-loader",
      })
    }
  }

  function initializeHubspotForms(forms: JQuery<HTMLElement>) {
    forms.each(function () {
      const form = $(this)
      if (hbspt) {
        hbspt.forms.create({
          target: "#contact-form",
          region: "na1",
          portalId: "6118348",
          formId: form.data("form-id"),
        })
      }
    })
  }

  function handleConsent(
    tcData: {
      cmpStatus: string
      customVendorConsents: Record<string, boolean | undefined>
    },
    success: boolean
  ) {
    if (!success || tcData.cmpStatus !== "loaded") {
      return
    }

    const vendorConsent = tcData.customVendorConsents
    const hubspotConsent = vendorConsent["s10"]
    const googleTagManagerConsent = vendorConsent["s905"]
    const vidyardConsent = vendorConsent["c58615"]

    if (googleTagManagerConsent) loadGoogleTagManager()
    if (hubspotConsent) loadHubspotForms()
    if (vidyardConsent) loadVidyard()

    $(".vidyard-video .consent-disclaimer").toggle(!vidyardConsent)
  }

  function initializeConsentActions() {
    $("#contact-form")
      .find(".button.consent")
      .off("click.hubspot")
      .on("click.hubspot", function () {
        __cmp && __cmp("setVendorConsent", ["s10", 1])
        return false
      })

    $(".modal.video-consent-dialog")
      .modal({
        autofocus: false,
        onApprove: function () {
          __cmp && __cmp("setVendorConsent", ["c58615", 1])
        },
      })
      .modal("attach events", ".vidyard-video .button.consent", "show")
  }

  initializeConsentActions()

  // Register consent handler
  const cmpInitialized = "__cmp" in window && !!__cmp
  if (cmpInitialized) {
    __tcfapi!("addEventListener", 2, handleConsent)
  } else {
    // Script is loaded asynchronously so neither cmp nor its stub is available
    // workaround: attach to the init event manually
    addEventListener("cmpEvent_init", function () {
      __tcfapi!("addEventListener", 2, handleConsent)
    })
  }
}

namespace Enterprise {
  $(() => {
    const container = $(".enterprise-sign-up")
    if (!container.length) {
      return
    }

    const form = container.find("form")
    const formElement = form.get(0)
    if (formElement) {
      const responseCallback: Form.ResponseCallback = (_message, payload) => {
        const showLoginHint = !!payload["loginHint"]
        const hint = form.find("[data-loginHint]")
        hint.toggleClass("show", showLoginHint)
      }

      Form.manage(formElement, responseCallback)
    }
  })
}
